import EditMerchantAdminForm from '@components/forms/EditMerchantAdminForm';
import { EcoLoader, EcoTab, EcoTabContent, EcoTabs } from '@components/shared';
import { FormFieldsConfig } from '@components/shared/EcoForm';
import { EcoPickerItem } from '@components/shared/EcoPicker';
import EcoScrollView from '@components/views/EcoScrollView';
import { MerchantAdmin, PKG_PROTECTION_PRICING_MODES } from '@ecocart/entities';
import { BackLink } from '@navigation/BackLink';
import { GlobalScreenProps } from '@navigation/types';
import { useQuery } from '@tanstack/react-query';
import { getMerchantAdmin } from '@utils/api/merchant';
import { EcoCartApiMerchantTabs, EcoCartGlobalMerchantTabs } from '@utils/constants/tabs';
import { View } from 'react-native';

const pricingModeItems: EcoPickerItem[] = [
  { label: 'Percentage AOV', value: PKG_PROTECTION_PRICING_MODES[0] },
  { label: 'Flat Rate', value: PKG_PROTECTION_PRICING_MODES[1] }
];

const formFieldsConfig: FormFieldsConfig<Partial<MerchantAdmin>>[] = [
  {
    field: 'pkgProtectionEnabled',
    type: 'checkbox',
    label: 'Enable Package Protection'
  },
  {
    field: 'pkgProtectionPricingMode',
    type: 'picker',
    items: pricingModeItems
  },
  {
    field: 'pkgProtectionPercentage'
  },
  {
    field: 'pkgProtectionFlatRateAmount'
  },
  {
    field: 'pkgProtectionOrderCapEnabled',
    type: 'checkbox',
    label: 'Enable Order Cap'
  },
  {
    field: 'pkgProtectionOrderCapAmount'
  },
  {
    field: 'claimFormUrl',
    label: 'Claim Form URL'
  },
  {
    field: 'minVariantPrice'
  },
  {
    field: 'lowerBoundOrderTotalCap'
  }
];

export default function MerchantProtectionScreen({ route }: GlobalScreenProps): JSX.Element {
  const shopName = route?.params?.shopName;
  const { data: merchantAdmin, refetch } = useQuery(['merchantAdmin', shopName], () => getMerchantAdmin(shopName));
  const EcoCartMerchantTabs = merchantAdmin?.platform === 'api' ? EcoCartApiMerchantTabs : EcoCartGlobalMerchantTabs;

  return (
    <EcoScrollView>
      <View className="flex-row">
        <BackLink href="/merchants" label="Back to Merchants" />
      </View>
      <EcoTabs
        tabs={EcoCartMerchantTabs.map(({ label, screenName }) => {
          return {
            label,
            screenName,
            screenParams: { shopName }
          } as EcoTab;
        })}
        prefix="Merchant"
        activeScreen="MerchantProtection"
      >
        <EcoTabContent title="Edit Package Protection Settings">
          {merchantAdmin ? (
            <EditMerchantAdminForm merchantAdmin={merchantAdmin} formFieldsConfig={formFieldsConfig} onSuccess={refetch} />
          ) : (
            <EcoLoader size="large" />
          )}
        </EcoTabContent>
      </EcoTabs>
    </EcoScrollView>
  );
}
